module.exports = __webpack_public_path__ + "img/land-cruiser-20.a8bf1ca0.png";